import React, { useEffect, useState } from 'react'
import ReservationSidebar from '../Commun/ReservationSidebar'
import ReservationHeader from '../Commun/ReservationHeader'
import { useProperty } from '../../PropertyContext';
import { Property, ReservationMealplan, ReservationRateCodeList } from '../../Services/Service';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReservationMasters } from '../../Redux/Slices/reservationMasterSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import { resetEditBooking, updateBooking } from '../../Redux/Slices/ReserEditBookingSlice';
import { fetchVoucherDetails } from '../../Redux/Slices/reservationVoucherSlice';

export const EditBookingDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedProperty } = useProperty();
  const location = useLocation();

  const { header, rooms, bookingInfo } = location.state || {};

  // BONRESID
  const bonresid = bookingInfo?.BONRESID || header?.BONRESID || "";

  const [mealplan, setMealplan] = useState([]);
  const [ratecode, setRatecode] = useState([]);
  const [Pms, setPMS] = useState();

  const { loading: updating } = useSelector((state) => state.ResereditBooking);

  // Date parse helper
  const parseDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (!isNaN(d.getTime())) {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    const months = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
    const parts = dateStr.trim().split(" ");
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = months[parts[1]];
      const year = parseInt(`20${parts[2]}`, 10);
      return `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    }
    return "";
  };

  // ── Stay Details — empty init ──
  const [arrivalDate, setArrivalDate] = useState("");
  const [departureDate, setDepartureDate] = useState("");
  const [nights, setNights] = useState(0);

  // ── Guest Details — empty init ──
  const [salutation, setSalutation] = useState("Mr.");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("+91");

  // ── Additional & Billing — empty init ──
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [gstCompanyName, setGstCompanyName] = useState("");
  const [gstAddress, setGstAddress] = useState("");
  const [billingInstruction, setBillingInstruction] = useState("");
  const [marketSegment, setMarketSegment] = useState("");
  const [businessSource, setBusinessSource] = useState("");
  const [guaranteeCode, setGuaranteeCode] = useState("");
  const [bookingComment, setBookingComment] = useState("");
  const [paymentComment, setPaymentComment] = useState("");

  // ── Room Rows — empty init ──
  const [roomRows, setRoomRows] = useState([]);

  // ── useEffect: jab bhi location.state aaye, sab states set karo ──
  useEffect(() => {
    if (!header && !bookingInfo) return;

    setArrivalDate(parseDate(bookingInfo?.CheckInDate) || "");
    setDepartureDate(parseDate(bookingInfo?.CheckOutDate) || "");
    setSalutation(header?.Title || "Mr.");
    setFirstName(header?.FirstName || "");
    setLastName(header?.LastName || "");
    setPhone(header?.Telephone || "");
    setEmail(header?.Email || "");
    setAddress(header?.Address || "");
    setCity(header?.City || "");
    setCountry(header?.Country || "");
    setState(header?.State || "");
    setCompanyName(bookingInfo?.CompanyName || "");
    setGstNumber(header?.RegTax_Number || "");
    setGstCompanyName(header?.Reg_CompName || "");
    setGstAddress(header?.RegCom_Address || "");
    setBillingInstruction(bookingInfo?.BillingInstructions || "");
    setMarketSegment(bookingInfo?.MarketSegment || "");
    setBusinessSource(bookingInfo?.BusinessSource || "");
    setGuaranteeCode(bookingInfo?.GuaranteeCodes || "");

    try {
      setBookingComment(JSON.parse(header?.BookingComment)?.[0]?.BookingComment || "");
    } catch { setBookingComment(""); }

    try {
      setPaymentComment(JSON.parse(header?.PaymentComment)?.[0]?.PaymentComment || "");
    } catch { setPaymentComment(""); }

  }, [header, bookingInfo]);

  // ── useEffect: rooms aane par roomRows set karo ──
  useEffect(() => {
    if (!rooms || rooms.length === 0) return;

    setRoomRows(rooms.map((room) => ({
      RoomID: room.RoomID || room.RoomId || 0,
      RoomName: room.RoomName,
      mealPlanID: room.MeelPlanCode || "",
      ratePlanID: room.RatePlanCode || "",
      mealPlanName: room.MeelPlan,
      ratePlanName: room.RatePlan,
      adults: room.adults || 0,
      child: room.Child || 0,
      extraBed: 0,
      amount: room.RoomRate || "",
      tax: String(room.Tax || ""),
      taxRate: room.TaxRate || "",
      total: room.NetAmount || "",
    })));
  }, [rooms]);

  const updateRoomRow = (index, field, value) => {
    setRoomRows(prev =>
      prev.map((row, i) => {
        if (i !== index) return row;
        const updatedRow = { ...row, [field]: value };
        const amount = Number(updatedRow.amount || 0);
        const tax = Number(updatedRow.tax || 0);
        const taxRate = (amount * tax) / 100;
        const total = amount + taxRate;
        return {
          ...updatedRow,
          taxRate: taxRate.toFixed(2),
          total: total.toFixed(2),
        };
      })
    );
  };

  // Nights calculate
  useEffect(() => {
    if (arrivalDate && departureDate) {
      const arrival = new Date(arrivalDate);
      const departure = new Date(departureDate);
      const diffTime = departure - arrival;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setNights(diffDays > 0 ? diffDays : 0);
    }
  }, [arrivalDate, departureDate]);

  // Mealplan fetch
  useEffect(() => {
    const FetchMealplan = async () => {
      try {
        const result = await ReservationMealplan(selectedProperty?.PropertyID);
        if (Array.isArray(result)) setMealplan(result);
      } catch (error) {
        console.log("error get meal plan", error);
      }
    };
    if (selectedProperty?.PropertyID) FetchMealplan();
  }, [selectedProperty]);

  // Ratecode fetch
  useEffect(() => {
    const fetchRatecode = async () => {
      try {
        const result = await ReservationRateCodeList(selectedProperty?.PropertyID);
        if (Array.isArray(result)) setRatecode(result);
      } catch (error) {
        console.log("error get rate code", error);
      }
    };
    if (selectedProperty?.PropertyID) fetchRatecode();
  }, [selectedProperty]);

  // Redux masters
  const { marketSegments, businessSources, guaranteeCodes } = useSelector((state) => state.reservationMasters);

  useEffect(() => {
    if (selectedProperty?.PropertyID) {
      dispatch(fetchReservationMasters(selectedProperty.PropertyID));
    }
  }, [selectedProperty, dispatch]);

  const countryCodes = [
    { code: "+93", country: "Afghanistan" },
    { code: "+61", country: "Australia" },
    { code: "+880", country: "Bangladesh" },
    { code: "+55", country: "Brazil" },
    { code: "+86", country: "China" },
    { code: "+20", country: "Egypt" },
    { code: "+33", country: "France" },
    { code: "+49", country: "Germany" },
    { code: "+852", country: "Hong Kong" },
    { code: "+91", country: "India" },
    { code: "+62", country: "Indonesia" },
    { code: "+98", country: "Iran" },
    { code: "+964", country: "Iraq" },
    { code: "+81", country: "Japan" },
    { code: "+60", country: "Malaysia" },
    { code: "+52", country: "Mexico" },
    { code: "+977", country: "Nepal" },
    { code: "+64", country: "New Zealand" },
    { code: "+92", country: "Pakistan" },
    { code: "+63", country: "Philippines" },
    { code: "+974", country: "Qatar" },
    { code: "+966", country: "Saudi Arabia" },
    { code: "+65", country: "Singapore" },
    { code: "+27", country: "South Africa" },
    { code: "+82", country: "South Korea" },
    { code: "+94", country: "Sri Lanka" },
    { code: "+971", country: "UAE" },
    { code: "+44", country: "United Kingdom" },
    { code: "+1", country: "United States" },
    { code: "+84", country: "Vietnam" }
  ];

  // Totals
  const totalAmount = roomRows.reduce((sum, row) => sum + Number(row.amount || 0), 0);
  const totalTaxAmount = roomRows.reduce((sum, row) => sum + Number(row.taxRate || 0), 0);
  const totalRowAmount = roomRows.reduce((sum, row) => sum + Number(row.total || 0), 0);

  const totalPayment = totalAmount * Number(nights || 0);
  const totalTax = totalTaxAmount * Number(nights || 0);
  const grandTotal = totalRowAmount * Number(nights || 0);

  const totalAdults = roomRows.reduce((sum, row) => sum + Number(row.adults || 0), 0);
  const totalChild = roomRows.reduce((sum, row) => sum + Number(row.child || 0), 0);

  // ── SUBMIT HANDLER ──
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      BONRESID: bonresid,
      Remarks: "Guest changed room and dates",

      BookingDetails: {
        CheckInDate: arrivalDate,
        CheckOutDate: departureDate,
        Adults: totalAdults,
        Child: totalChild,
        CompanyName: companyName,
        BillingInstructions: billingInstruction,
        BusinessSource: businessSource,
        GuaranteeCodes: guaranteeCode,
        BookingComment: bookingComment,
        PaymentComment: paymentComment,
        TotalPayment: parseFloat(totalPayment.toFixed(2)),
        Tax: parseFloat(totalTax.toFixed(2)),
        TotalAfterTax: parseFloat(grandTotal.toFixed(2)),
      },

      GuestDetails: [
        {
          Title: salutation,
          FirstName: firstName,
          LastName: lastName,
          EMailAddress: email,
          MobileNumber: phone,
          Country: country,
          State: state,
          City: city,
          Address: address,
        },
      ],

      CompanyDetails: [
        {
          CompanyName: companyName,
          MarketSegment: marketSegment,
          RegistrationNumber: gstNumber,
          RegistrationCompanyName: gstCompanyName,
          RegistrationCompanyAddress: gstAddress,
        },
      ],

      RoomDetails: roomRows.map((row) => ({
        RoomID: row.RoomID,
        RatePlanID: row.ratePlanID,
        MealPlanID: row.mealPlanID,
        TotalRoom: 1,
        RoomRate: parseFloat(row.amount || 0),
        Adults: Number(row.adults || 0),
        Child: Number(row.child || 0),
        Tax: parseFloat(row.tax || 0),
        TaxRate: parseFloat(row.taxRate || 0),
        NetAmount: parseFloat(row.total || 0),
      })),
    };

    // console.log("Payload JSON:", JSON.stringify(payload, null, 2));

    const result = await dispatch(updateBooking(payload));

    if (updateBooking.fulfilled.match(result)) {
      swal("Success!", "Booking has been updated successfully.", "success").then(() => {
        dispatch(resetEditBooking());
        dispatch(fetchVoucherDetails(bonresid));
        navigate(`/Reservation/VoucherDetail/${bonresid}`);
      });
    } else {
      swal("Failed!", result.payload || "Something went wrong. Please try again.", "error");
    }
  };

  useEffect(() => {
    const FetchPMS = async () => {
      if (!selectedProperty?.PropertyID) return;
      try {
        const result = await Property();
        const matched = result.find(p => p.PropertyID === selectedProperty.PropertyID);
        setPMS(matched || null);
      } catch (error) {
        console.log("error fetch PMS", error);
      }
    };
    FetchPMS();
  }, [selectedProperty]);

  return (
    <>
      <div className="wrapper">
        <ReservationSidebar />
        <div className="main-panel">
          <ReservationHeader />
          <div className="container">
            <div className="page-inner">

              <div className="d-flex justify-content-between align-items-end mb-4">
                <h2 className="fw-bold mb-1" style={{ fontSize: 24, letterSpacing: "-0.02em" }}>
                  Reservation Edit Booking Details
                </h2>
              </div>

              <form onSubmit={handleSubmit}>

                {/* ── Stay Details ── */}
                <div className="row g-4 mb-4">
                  <div className="col-lg-12">
                    <div className="card h-100">
                      <div className="card-header d-flex align-items-center">
                        <span className="material-symbols-outlined me-2 text-primary">calendar_today</span>
                        Stay Details
                      </div>
                      <div className="card-body">
                        <div className="row g-3">
                          <div className="col-md-3">
                            <label className="form-label">Arrival Date</label>
                            <input
                              className="form-control"
                              type="date"
                              value={arrivalDate}
                              onChange={(e) => setArrivalDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Departure Date</label>
                            <input
                              className="form-control"
                              type="date"
                              value={departureDate}
                              min={arrivalDate}
                              onChange={(e) => setDepartureDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">Nights</label>
                            <input
                              className="form-control fw-bold text-primary bg-light"
                              readOnly
                              type="number"
                              value={nights}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ── Room & Rates ── */}
                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <span className="material-symbols-outlined me-2 text-primary">king_bed</span>
                      Room &amp; Rates
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table align-middle mb-0">
                      <thead>
                        <tr>
                          <th className="ps-4" style={{ width: "250px" }}>Room Type</th>
                          <th style={{ width: "170px" }}>Meal Plan</th>
                          {Pms?.PMS === "Opera" && (<th style={{ width: "170px" }}>Rate Plan</th>)}
                          <th className="text-center">Adults</th>
                          <th className="text-center">Child</th>
                          <th className="text-center">Extra Bed</th>
                          <th className="text-center" style={{ width: "120px" }}>Amount</th>
                          <th className="text-center" style={{ width: "90px" }}>Tax (%)</th>
                          <th className="text-center">Tax Rate</th>
                          <th className="text-center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {roomRows.map((row, index) => (
                          <tr key={index}>
                            <td className="ps-4 fw-bold">{row.RoomName}</td>

                            <td>
                              <select
                                className="form-select"
                                value={row.mealPlanID}
                                onChange={(e) => updateRoomRow(index, "mealPlanID", e.target.value)}
                              >
                                <option value="">Select Meal Plan</option>
                                {mealplan?.map((item) => (
                                  <option key={item.MealPlanID} value={item.Code}>
                                    {item.Name}
                                  </option>
                                ))}
                              </select>
                            </td>

                            {Pms?.PMS === "Opera" && (
                              <td>
                                <select
                                  className="form-select"
                                  value={row.ratePlanID}
                                  onChange={(e) => updateRoomRow(index, "ratePlanID", e.target.value)}
                                >
                                  <option value="">Select Rate Plan</option>
                                  {ratecode?.map((item) => (
                                    <option key={item.RateCodeID} value={item.Code}>
                                      {item.Name}
                                    </option>
                                  ))}
                                </select>
                              </td>
                            )}

                            <td>
                              <div className="btn-group btn-group-sm d-flex align-items-center justify-content-center">
                                <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                  onClick={() => updateRoomRow(index, "adults", Math.max(1, row.adults - 1))}>
                                  <i className="fas fa-minus"></i>
                                </button>
                                <span className="px-3 fw-bold">{row.adults}</span>
                                <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                  onClick={() => updateRoomRow(index, "adults", row.adults + 1)}>
                                  <i className="fas fa-plus"></i>
                                </button>
                              </div>
                            </td>

                            <td>
                              <div className="btn-group btn-group-sm d-flex align-items-center justify-content-center">
                                <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                  onClick={() => updateRoomRow(index, "child", Math.max(0, row.child - 1))}>
                                  <i className="fas fa-minus"></i>
                                </button>
                                <span className="px-3 fw-bold text-muted">{row.child}</span>
                                <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                  onClick={() => updateRoomRow(index, "child", row.child + 1)}>
                                  <i className="fas fa-plus"></i>
                                </button>
                              </div>
                            </td>

                            <td className="text-center">
                              <div className="btn-group btn-group-sm d-flex align-items-center justify-content-center">
                                <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                  onClick={() => updateRoomRow(index, "extraBed", Math.max(0, row.extraBed - 1))}>
                                  <i className="fas fa-minus"></i>
                                </button>
                                <span className="px-3 fw-bold">{row.extraBed}</span>
                                <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                  onClick={() => updateRoomRow(index, "extraBed", row.extraBed + 1)}>
                                  <i className="fas fa-plus"></i>
                                </button>
                              </div>
                            </td>

                            <td className="text-end">
                              <input
                                className="form-control"
                                type="number"
                                value={row.amount}
                                onChange={(e) => updateRoomRow(index, "amount", e.target.value)}
                              />
                            </td>

                            <td className="text-end text-muted">
                              <select
                                className="form-select"
                                value={row.tax}
                                onChange={(e) => updateRoomRow(index, "tax", e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="5">5%</option>
                                <option value="18">18%</option>
                              </select>
                            </td>

                            <td className="text-center text-muted small fw-bold">{row.taxRate}</td>
                            <td className="text-center pe-4 fw-bold text-primary">{row.total}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          {Pms?.PMS === "Opera" && (<td></td>)}
                          <td colSpan={5} className="text-end fw-bold">Total -</td>
                          <td className="text-end fw-bold">{totalAmount.toFixed(2)}</td>
                          <td></td>
                          <td className="text-end fw-bold">{totalTaxAmount.toFixed(2)}</td>
                          <td className="text-end pe-4 fw-bold">{totalRowAmount.toFixed(2)}</td>
                        </tr>
                        <tr>
                          {Pms?.PMS === "Opera" && (<td></td>)}
                          <td colSpan={5} className="text-end fw-bold">Grand Total Of {nights} Nights -</td>
                          <td className="text-end fw-bold">{totalPayment.toFixed(2)}</td>
                          <td></td>
                          <td className="text-end fw-bold">{totalTax.toFixed(2)}</td>
                          <td className="text-end pe-4 fw-bold">{grandTotal.toFixed(2)}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                {/* ── Guest Details ── */}
                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <span className="material-symbols-outlined me-2 text-primary">person</span>
                      Guest Details
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row g-3">
                      <div className="col-md-2">
                        <label className="form-label">Salutation</label>
                        <select className="form-select form-control" value={salutation} onChange={(e) => setSalutation(e.target.value)}>
                          <option>Mr.</option>
                          <option>Ms.</option>
                          <option>Dr.</option>
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">First Name</label>
                        <input className="form-control" placeholder="e.g. John" type="text"
                          value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Last Name</label>
                        <input className="form-control" placeholder="e.g. Doe" type="text"
                          value={lastName} onChange={(e) => setLastName(e.target.value)} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Phone Number</label>
                        <div className="input-group">
                          <select className="form-select" style={{ maxWidth: 100 }} value={countryCode}
                            onChange={(e) => setCountryCode(e.target.value)}>
                            {countryCodes.map((item) => (
                              <option key={item.code} value={item.code}>{item.code}</option>
                            ))}
                          </select>
                          <input className="form-control" placeholder="Enter phone" type="tel"
                            value={phone} onChange={(e) => setPhone(e.target.value)} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ── Additional & Billing ── */}
                <div className="card mb-4">
                  <div className="card-header d-flex align-items-center">
                    <span className="material-symbols-outlined me-2 text-primary">receipt_long</span>
                    Additional &amp; Billing Details
                  </div>
                  <div className="card-body">
                    <div className="row g-3 mb-4">
                      <div className="col-md-4">
                        <label className="form-label">Email:</label>
                        <input className="form-control" placeholder="Enter email" type="email"
                          value={email} onChange={(e) => setEmail(e.target.value)} />
                        <div className="form-check mt-2">
                          <input className="form-check-input" id="emailVoucher" type="checkbox" />
                          <label className="form-check-label small text-muted" htmlFor="emailVoucher">
                            Do want to receive Booking Voucher on email?
                          </label>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <label className="form-label">Address</label>
                        <textarea className="form-control" placeholder="Enter Address" rows={3}
                          style={{ resize: "none" }} value={address} onChange={(e) => setAddress(e.target.value)} />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">City</label>
                        <input className="form-control" placeholder="Enter City" type="text"
                          value={city} onChange={(e) => setCity(e.target.value)} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Country</label>
                        <input className="form-control" placeholder="Enter Country" type="text"
                          value={country} onChange={(e) => setCountry(e.target.value)} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">State</label>
                        <input className="form-control" placeholder="Enter State" type="text"
                          value={state} onChange={(e) => setState(e.target.value)} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Company Name</label>
                        <input className="form-control" placeholder="Enter Company Name" type="text"
                          value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                      </div>
                    </div>

                    {/* GST Section */}
                    <div className="gst-section mb-4">
                      <h6 className="small fw-bold mb-3 d-flex align-items-center">
                        <span className="material-symbols-outlined fs-6 me-1">verified</span>
                        Enter GST Details (Optional)
                      </h6>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label className="form-label">Registration Number</label>
                          <input className="form-control bg-white" placeholder="Enter Registration Number" type="text"
                            value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">Registered Company name</label>
                          <input className="form-control bg-white" placeholder="Enter Registered Company Name" type="text"
                            value={gstCompanyName} onChange={(e) => setGstCompanyName(e.target.value)} />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">Registered Company address</label>
                          <textarea className="form-control bg-white" placeholder="Registered Company Address" rows={2}
                            style={{ resize: "none" }} value={gstAddress} onChange={(e) => setGstAddress(e.target.value)} />
                        </div>
                      </div>
                    </div>

                    {/* Billing Dropdowns */}
                    <div className="row g-3 mb-4">
                      <div className="col-md-3">
                        <label className="form-label">Billing Instructions:</label>
                        <select className="form-select form-control" value={billingInstruction}
                          onChange={(e) => setBillingInstruction(e.target.value)}>
                          <option value="">Select Billing Instruction</option>
                          <option value="Pay at hotel">Pay at hotel</option>
                          <option value="Prepaid">Prepaid</option>
                          <option value="Send Invoice">Send Invoice</option>
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Market Segment</label>
                        <select className="form-select form-control" value={marketSegment}
                          onChange={(e) => setMarketSegment(e.target.value)}>
                          <option value="">Select</option>
                          {marketSegments?.map((item) => (
                            <option key={item.ID} value={item.Code}>{item.MarketSeg}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Business Source</label>
                        <select className="form-select form-control" value={businessSource}
                          onChange={(e) => setBusinessSource(e.target.value)}>
                          <option value="">Select</option>
                          {businessSources?.map((item) => (
                            <option key={item.ID} value={item.Code}>{item.BusinessSource}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Guarantee Codes</label>
                        <select className="form-select form-control" value={guaranteeCode}
                          onChange={(e) => setGuaranteeCode(e.target.value)}>
                          <option value="">Select</option>
                          {guaranteeCodes?.map((item) => (
                            <option key={item.ID} value={item.Code}>{item.guaranteeCodes}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Comments */}
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label">Booking Comment</label>
                        <textarea className="form-control" placeholder="Special Requirement" rows={2}
                          style={{ resize: "none" }} value={bookingComment}
                          onChange={(e) => setBookingComment(e.target.value)} />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Payment Comment</label>
                        <textarea className="form-control" placeholder="Payment Comment" rows={2}
                          style={{ resize: "none" }} value={paymentComment}
                          onChange={(e) => setPaymentComment(e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>

                {/* ── Summary Footer ── */}
                <div className="summary-bar d-flex justify-content-between align-items-center">
                  <div className="d-flex gap-5">
                    <div>
                      <span className="summary-label">TOTAL AMOUNT</span>
                      <span className="fs-3 fw-black">₹{grandTotal.toFixed(2)}</span>
                    </div>
                  </div>
                  <div className="d-flex gap-3">
                    <button
                      className="btn btn-primary px-5 py-2 fw-bold shadow"
                      type="submit"
                      disabled={updating}
                    >
                      {updating ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" />
                          Updating...
                        </>
                      ) : "Update"}
                    </button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .material-symbols-outlined {
          font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24;
          vertical-align: middle;
        }
        .card {
          border: 1px solid var(--outline-variant);
          border-radius: 0.75rem;
          box-shadow: 0px 1px 3px rgba(0,0,0,.05), 0px 4px 6px rgba(0,0,0,.05);
          margin-bottom: 24px;
          overflow: hidden;
        }
        .card-header {
          background-color: rgba(242,244,246,0.5);
          border-bottom: 1px solid var(--outline-variant);
          padding: 1rem;
          font-weight: 600;
        }
        .form-label { font-size:.8125rem; font-weight:500; color:var(--secondary-text); margin-bottom:.25rem; }
        .form-control,.form-select { border-radius:.5rem; font-size:.875rem; }
        .form-control:focus,.form-select:focus { border-color:var(--bs-primary); box-shadow:0 0 0 .25rem rgba(30,64,175,.1); }
        .table th { background-color:rgba(242,244,246,.5); font-size:11px; text-transform:uppercase; letter-spacing:.05em; color:var(--secondary-text); font-weight:700; border-bottom:1px solid var(--outline-variant); }
        .gst-section { background-color:var(--surface-container); padding:1rem; border-radius:.5rem; border:1px solid rgba(196,197,213,.3); }
        .summary-bar { background-color:#dde1ff; color:#001453; padding:1.5rem; border-radius:.75rem; box-shadow:0 4px 6px -1px rgba(0,0,0,.1); }
        .summary-label { font-size:11px; font-weight:700; letter-spacing:.05em; opacity:.7; display:block; }
      `}</style>
    </>
  );
};